import { Receipt } from '@mui/icons-material'
import TransactionList from './TransactionList'
import TransactionEdit from './TransactionEdit'

const transactionIndex = {
  list: TransactionList,
  edit: TransactionEdit,
  show: TransactionList,
  icon: Receipt,
}
export default transactionIndex
